import React from 'react';
import svgCaret from '../../svgs/caret-down.svg';

export default class SearchPanel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};

		this.toggle = this.toggle.bind(this);
		this.handleBtn = this.handleBtn.bind(this);
        this.handleEsc = this.handleEsc.bind(this);
    }

	componentDidMount() {
		const btn = document.querySelector('#menu-search-btn');
		if (btn) {
			btn.addEventListener('click', this.handleBtn);
		}

		document.addEventListener('keydown', this.handleEsc);
	}

	componentWillUnmount() {
		const btn = document.querySelector('#menu-search-btn');
		if (btn) {
			btn.removeEventListener('click', this.handleBtn);
		}

		document.removeEventListener('keydown', this.handleEsc);
	}

    handleEsc(e) {
		if (e.keyCode === 27) {
			e.preventDefault();
			this.toggle();
		}
	}

	handleBtn(e) {
		e.preventDefault();
		this.toggle();
	}

	toggle() {
		if (this.state.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.setState({isOpen: true});
	}

	close() {
		this.setState({isOpen: false});
	}

	render() {
		return (
			<div className={`SearchPanel SearchPanel--${this.state.isOpen ? 'open' : 'closed'} ${this.props.class}`}>
				<div className='SearchPanel_handle' onClick={this.toggle}>
					<div className='SearchPanel_handle_icon' dangerouslySetInnerHTML={{__html: svgCaret}}/>
				</div>
				<div className='SearchPanel_body' disabled={!this.state.isOpen}>
					{this.props.children}
				</div>
			</div>
		);
	}
}
